<div class="AmInputSwitch" [ngClass]="'AmInputSwitch--'+size" (click)="onContainerClick()" *ngIf="showApplyAll">
  <div class="AmInputSwitch-label">
    <span class="text-am-white fs-20px lh-26px fw-regular">
      {{ label | translate }}
    </span>
  </div>
  <label class="AmInputSwitch-switch" [ngClass]="className">
    <input
      type="checkbox"
      [(ngModel)]="val"
      (change)="onContainerClick()"
    />
    <span class="AmInputSwitch-circle"></span>
  </label>
</div>